export const FISH_FRESHNESS_DAYS = 2;
export const FISH_FREEZER_THRESHOLD_DAYS = 3;

const FISH_PHRASES = ['sea bass', 'sea bream'];
const FISH_TOKENS = new Set([
  'fish', 'salmon', 'tuna', 'cod', 'hake', 'trout', 'seabass', 'bass', 'bream',
  'halibut', 'mackerel', 'sardine', 'anchovy', 'tilapia', 'haddock', 'sole',
  'snapper', 'shrimp', 'prawn', 'mussel', 'clam', 'shellfish', 'pescado',
  'atun', 'bacalao', 'merluza', 'lubina', 'dorada', 'gamba', 'langostino',
  'seafood', 'лосось', 'рыба', 'тунец', 'треска', 'форель', 'мидии', 'морепродукты'
]);
const FISH_STEMS = ['рыб', 'лосос', 'треск', 'форел', 'кревет', 'миди', 'морепродукт', 'бас', 'shrimp', 'prawn', 'gamba', 'langostino'];

const SHRIMP_TOKENS = new Set(['shrimp', 'prawn', 'gamba', 'langostino', 'camarón', 'camarones', 'креветка', 'креветки']);
const SHRIMP_STEMS = ['кревет', 'shrimp', 'prawn', 'gamba', 'langostino'];
const SHELLFISH_TOKENS = new Set(['mussel', 'mussels', 'clam', 'clams', 'shellfish', 'seafood', 'мидии', 'морепродукты']);
const SHELLFISH_STEMS = ['миди', 'морепродукт'];

const TARGET_TEXT_PATTERNS = {
  fish: /fish|pescado|peix|poisson|peste|pesce|рыб|рибу|риб|salmon|tuna|cod|hake|trout|лосос|тунец|треск|форел/i,
  shrimp: /shrimp|prawn|gamba|langostino|camar[oó]n|crevette|crevet|gamber|кревет/i,
  seafood: /seafood|shellfish|mussel|clam|marisc|marisco|frutti di mare|fructe de mare|морепродукт|миди/i,
};

const THAW_STEP_COPY = {
  en: {
    fish: {
      title: 'Thaw the fish (30 min)',
      detail: 'Keep the fish sealed and submerge it in cold water for 20-30 min, then cook it immediately.'
    },
    shrimp: {
      title: 'Thaw the shrimp (30 min)',
      detail: 'Keep the shrimp sealed and submerge them in cold water for 20-30 min, then cook them immediately.'
    },
    seafood: {
      title: 'Thaw the seafood (30 min)',
      detail: 'Keep the seafood sealed and submerge it in cold water for 20-30 min, then cook it immediately.'
    }
  },
  es: {
    fish: {
      title: 'Descongela el pescado (30 min)',
      detail: 'Mantén el pescado cerrado y sumérgelo en agua fría 20-30 min; cocínalo inmediatamente después.'
    },
    shrimp: {
      title: 'Descongela las gambas (30 min)',
      detail: 'Mantén las gambas cerradas y sumérgelas en agua fría 20-30 min; cocínalas inmediatamente después.'
    },
    seafood: {
      title: 'Descongela el marisco (30 min)',
      detail: 'Mantén el marisco cerrado y sumérgelo en agua fría 20-30 min; cocínalo inmediatamente después.'
    }
  },
  ru: {
    fish: {
      title: 'Разморозьте рыбу (30 мин)',
      detail: 'Оставьте рыбу в герметичной упаковке и погрузите в холодную воду на 20-30 мин, затем сразу готовьте.'
    },
    shrimp: {
      title: 'Разморозьте креветки (30 мин)',
      detail: 'Оставьте креветки в герметичной упаковке и погрузите в холодную воду на 20-30 мин, затем сразу готовьте.'
    },
    seafood: {
      title: 'Разморозьте морепродукты (30 мин)',
      detail: 'Оставьте морепродукты в герметичной упаковке и погрузите в холодную воду на 20-30 мин, затем сразу готовьте.'
    }
  },
  ca: {
    fish: {
      title: 'Descongela el peix (30 min)',
      detail: 'Mantingues el peix tancat i submergeix-lo en aigua freda 20-30 min; cuina\'l immediatament després.'
    },
    shrimp: {
      title: 'Descongela les gambes (30 min)',
      detail: 'Mantingues les gambes tancades i submergeix-les en aigua freda 20-30 min; cuina-les immediatament després.'
    },
    seafood: {
      title: 'Descongela el marisc (30 min)',
      detail: 'Mantingues el marisc tancat i submergeix-lo en aigua freda 20-30 min; cuina\'l immediatament després.'
    }
  },
  fr: {
    fish: {
      title: 'Decongelez le poisson (30 min)',
      detail: 'Gardez le poisson fermé et plongez-le dans l\'eau froide 20-30 min, puis cuisez-le aussitôt.'
    },
    shrimp: {
      title: 'Decongelez les crevettes (30 min)',
      detail: 'Gardez les crevettes fermées et plongez-les dans l\'eau froide 20-30 min, puis cuisez-les aussitôt.'
    },
    seafood: {
      title: 'Decongelez les fruits de mer (30 min)',
      detail: 'Gardez les fruits de mer fermés et plongez-les dans l\'eau froide 20-30 min, puis cuisez-les aussitôt.'
    }
  },
  ro: {
    fish: {
      title: 'Dezgheata pestele (30 min)',
      detail: 'Ține peștele sigilat și scufundă-l în apă rece 20-30 min, apoi gătește-l imediat.'
    },
    shrimp: {
      title: 'Dezgheata crevetii (30 min)',
      detail: 'Ține creveții sigilați și scufundă-i în apă rece 20-30 min, apoi gătește-i imediat.'
    },
    seafood: {
      title: 'Dezgheata fructele de mare (30 min)',
      detail: 'Ține fructele de mare sigilate și scufundă-le în apă rece 20-30 min, apoi gătește-le imediat.'
    }
  },
  it: {
    fish: {
      title: 'Scongela il pesce (30 min)',
      detail: 'Tieni il pesce sigillato e immergilo in acqua fredda per 20-30 min, poi cuocilo subito.'
    },
    shrimp: {
      title: 'Scongela i gamberi (30 min)',
      detail: 'Tieni i gamberi sigillati e immergili in acqua fredda per 20-30 min, poi cuocili subito.'
    },
    seafood: {
      title: 'Scongela i frutti di mare (30 min)',
      detail: 'Tieni i frutti di mare sigillati e immergili in acqua fredda per 20-30 min, poi cuocili subito.'
    }
  },
  uk: {
    fish: {
      title: 'Розморозьте рибу (30 хв)',
      detail: 'Залиште рибу в герметичній упаковці й занурте в холодну воду на 20-30 хв, потім одразу готуйте.'
    },
    shrimp: {
      title: 'Розморозьте креветки (30 хв)',
      detail: 'Залиште креветки в герметичній упаковці й занурте в холодну воду на 20-30 хв, потім одразу готуйте.'
    },
    seafood: {
      title: 'Розморозьте морепродукти (30 хв)',
      detail: 'Залиште морепродукти в герметичній упаковці й занурте в холодну воду на 20-30 хв, потім одразу готуйте.'
    }
  }
};

const THAW_TEXT_PATTERN = /thaw|defrost|freezer|congelador|descongel|decongel|décongel|dezgheat|морозил|размороз|розмороз|congelateur|congelator|scongel/i;

const parseDays = (value) => {
  if (value === null || value === undefined) return null;
  const match = String(value).match(/\d+/);
  if (!match) return null;
  const days = Number(match[0]);
  return Number.isFinite(days) && days > 0 ? days : null;
};

const normalizeFoodName = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const isFishIngredientName = (value) => {
  const text = normalizeFoodName(value);
  if (!text) return false;
  if (FISH_PHRASES.some(phrase => text.includes(phrase))) return true;

  const tokens = text.split(/[^a-zа-яё]+/i).filter(Boolean);
  return tokens.some(token => FISH_TOKENS.has(token) || FISH_STEMS.some(stem => token.startsWith(stem)));
};

export const isFishProductItem = (item) => isFishIngredientName(item?.productName)
  || isFishIngredientName(item?.name)
  || isFishIngredientName(item?.originalName);

const getSeafoodKind = (value) => {
  const text = normalizeFoodName(value);
  const tokens = text.split(/[^a-zа-яё]+/i).filter(Boolean);

  if (tokens.some(token => SHRIMP_TOKENS.has(token) || SHRIMP_STEMS.some(stem => token.startsWith(stem)))) {
    return 'shrimp';
  }

  if (tokens.some(token => SHELLFISH_TOKENS.has(token) || SHELLFISH_STEMS.some(stem => token.startsWith(stem)))) {
    return 'seafood';
  }

  return 'fish';
};

const resolveSeafoodThawKind = (kinds) => {
  const values = Array.from(kinds || []).filter(Boolean);
  if (values.length === 0) return 'fish';
  const unique = new Set(values);
  if (unique.size === 1) return values[0];
  return 'seafood';
};

// ---- Raw meat freshness caps -------------------------------------------------
// Raw meat is far more perishable than the LLM tends to assume. Like fresh fish,
// it MUST hard-cap a dish's freshness so the displayed "fresh for N days" can
// never exceed the safe fridge life of the most perishable raw protein:
//   ground / minced meat & poultry -> 2 days
//   raw poultry pieces             -> 2 days
//   raw red-meat cuts (beef/pork…)  -> 3 days
// Cured / smoked / processed meats (ham, bacon, chorizo, salami…) keep much
// longer and are intentionally NOT capped.
export const GROUND_MEAT_FRESHNESS_DAYS = 2;
export const POULTRY_FRESHNESS_DAYS = 2;
export const RED_MEAT_FRESHNESS_DAYS = 3;

const CURED_MEAT_TOKENS = new Set([
  'ham', 'bacon', 'chorizo', 'salami', 'prosciutto', 'pancetta', 'pepperoni',
  'mortadella', 'speck', 'jamon', 'fuet', 'guanciale', 'jerky', 'salchichon',
  'sobrasada', 'cecina', 'bresaola', 'pastrami', 'lardons',
  'ветчина', 'бекон', 'салями', 'хамон', 'пастрами', 'прошутто', 'панчетта'
]);
const CURED_MEAT_STEMS = [
  'chorizo', 'salam', 'prosciut', 'pancett', 'pepperoni', 'mortadell', 'jamon',
  'salchichon', 'sobrasad', 'bresaol', 'pastrami', 'cured', 'smoked',
  'ветчин', 'салям', 'хамон', 'панчетт', 'прошут', 'копчен'
];

// Unambiguous ground/processed-meat product words (cap with no meat token).
const GROUND_MEAT_WORD_STEMS = [
  'meatball', 'meatloaf', 'burger', 'hamburg', 'patty', 'patties', 'mincemeat',
  'albondig', 'polpett', 'frikadel', 'cevap', 'kofta', 'kofte',
  'фарш', 'котлет', 'тефтел', 'фрикадел'
];
// Ambiguous processing words -> ground MEAT only with a real meat token present
// (so "minced garlic" / "ground cinnamon" are NOT treated as meat).
const GROUND_QUALIFIER_TOKENS = new Set([
  'ground', 'minced', 'mince', 'grind',
  'molida', 'molido', 'picada', 'picado', 'hache', 'hachee',
  'macinata', 'macinato', 'tocata', 'tocat',
  'молотый', 'молотая', 'рубленый', 'рубленое', 'рубленая'
]);

const POULTRY_TOKENS = new Set([
  'chicken', 'turkey', 'duck', 'poultry', 'pollo', 'pavo', 'pato', 'pui',
  'poulet', 'dinde', 'canard', 'tacchino', 'anatra',
  'курица', 'куриное', 'куриная', 'курицы', 'курицу', 'индейка', 'индейки',
  'индюшка', 'утка', 'утки', 'цыпленок', 'цыплята'
]);
const POULTRY_STEMS = ['chicken', 'turkey', 'duck', 'poultry', 'pollo', 'poulet', 'tacchino', 'gallin', 'птиц'];

const RED_MEAT_TOKENS = new Set([
  'res', 'buey', 'manzo', 'maiale', 'vitello', 'agnello', 'veau', 'porc', 'vacuno'
]);
const RED_MEAT_STEMS = [
  'beef', 'pork', 'lamb', 'veal', 'steak', 'sirloin', 'brisket', 'ribeye',
  'tenderloin', 'mutton', 'venison', 'oxtail', 'meat', 'sausag',
  'carne', 'ternera', 'cerdo', 'cordero', 'cochinillo', 'solomillo', 'salchich',
  'boeuf', 'agneau', 'mouton', 'salsicc',
  'говяд', 'свин', 'баран', 'телят', 'мясо'
];

const anyToken = (tokens, set, stems) =>
  tokens.some(t => set.has(t) || (stems && stems.some(stem => t.startsWith(stem))));

/**
 * Deterministic fridge freshness cap (in days) for a raw meat/poultry ingredient,
 * or null when the name is not raw meat (or is cured/smoked, or is fish — fish has
 * its own dedicated rule). Guarantees a dish never advertises a longer shelf life
 * than its most perishable raw protein actually allows.
 */
export const getRawMeatFridgeCap = (value) => {
  const text = normalizeFoodName(value);
  if (!text) return null;
  if (isFishIngredientName(value)) return null; // fish handled separately

  const tokens = text.split(/[^a-zа-яё]+/i).filter(Boolean);
  if (tokens.length === 0) return null;

  // Cured / smoked / processed meats keep far longer than raw meat -> never cap.
  if (anyToken(tokens, CURED_MEAT_TOKENS, CURED_MEAT_STEMS)) return null;

  const isPoultry = anyToken(tokens, POULTRY_TOKENS, POULTRY_STEMS);
  const isRedMeat = anyToken(tokens, RED_MEAT_TOKENS, RED_MEAT_STEMS);
  const hasGroundWord = tokens.some(t => GROUND_MEAT_WORD_STEMS.some(stem => t.startsWith(stem)));
  const hasGroundQualifier = tokens.some(t => GROUND_QUALIFIER_TOKENS.has(t));

  // Ground / minced meat & poultry spoils fastest.
  if (hasGroundWord || (hasGroundQualifier && (isRedMeat || isPoultry))) {
    return GROUND_MEAT_FRESHNESS_DAYS;
  }
  if (isPoultry) return POULTRY_FRESHNESS_DAYS;
  if (isRedMeat) return RED_MEAT_FRESHNESS_DAYS;
  return null;
};

// Canned / jarred / preserved proteins (canned tuna, sardines in oil, etc.) are
// shelf-stable pantry items. They must NEVER be treated as fresh fish/meat and
// forced into the fridge with a short 2-3 day life.
const CANNED_PROTEIN_TOKENS = new Set([
  'canned', 'tinned', 'conserva', 'conservas', 'enlatado', 'enlatada', 'lata',
  'preserved', 'консервы', 'консерва', 'консервированный', 'консервированная'
]);
const CANNED_PHRASE_PATTERNS = [
  'in oil', 'in olive oil', 'in sunflower oil', 'in brine', 'in spring water',
  'en aceite', 'en su jugo', 'en conserva', 'al natural',
  'в масле', 'в собственном соку', 'в рассоле'
];
export const isShelfStableProteinName = (value) => {
  const text = normalizeFoodName(value);
  if (!text) return false;
  if (CANNED_PHRASE_PATTERNS.some(p => text.includes(p))) return true;
  const tokens = text.split(/[^a-zа-яё]+/i).filter(Boolean);
  return tokens.some(t =>
    CANNED_PROTEIN_TOKENS.has(t) ||
    t.startsWith('conserv') || t.startsWith('enlatad') || t.startsWith('консерв')
  );
};

/**
 * Effective fridge/pantry freshness for one ingredient_storage entry. Frozen
 * entries are NOT capped (they don't spoil before the planned meal); canned /
 * jarred proteins are shelf-stable and keep their full life; fresh fish and raw
 * meat are capped to their safe fridge life.
 */
const effectiveEntryFreshnessDays = (entry) => {
  const parsed = parseDays(entry?.shelf_life_days);
  const location = String(entry?.storage || '').toLowerCase();
  if (location === 'freezer') return parsed;
  if (isShelfStableProteinName(entry?.name)) return parsed;

  if (isFishIngredientName(entry?.name)) {
    return parsed ? Math.min(parsed, FISH_FRESHNESS_DAYS) : FISH_FRESHNESS_DAYS;
  }
  const meatCap = getRawMeatFridgeCap(entry?.name);
  if (meatCap) {
    return parsed ? Math.min(parsed, meatCap) : meatCap;
  }
  return parsed;
};

export const computeRecipeFreshnessDays = (instructions) => {
  const storage = instructions?.ingredient_storage;
  if (!Array.isArray(storage) || storage.length === 0) return null;

  const days = storage
    .map(effectiveEntryFreshnessDays)
    .filter(day => Number.isFinite(day) && day > 0);

  if (days.length === 0) return null;
  return Math.max(Math.min(...days), FISH_FRESHNESS_DAYS);
};

const getThawStepCopy = (language, kind = 'fish') => {
  const lang = language || 'en';
  const baseLang = lang?.split('-')[0];
  const languageCopies = THAW_STEP_COPY[baseLang] || THAW_STEP_COPY.en;
  return languageCopies[kind] || languageCopies.fish;
};

const stepText = (step) => {
  if (!step) return '';
  if (typeof step === 'string') return step;
  const title = step.step_title || step.title || '';
  const details = Array.isArray(step.details) ? step.details.join(' ') : '';
  return `${title} ${details}`;
};

const hasTargetThawText = (step, kind) => {
  const targetPattern = TARGET_TEXT_PATTERNS[kind] || TARGET_TEXT_PATTERNS.fish;
  return targetPattern.test(stepText(step));
};

const ensureFishThawInstruction = (instructions, language, kind = 'fish') => {
  if (!instructions || typeof instructions !== 'object') return;

  const steps = Array.isArray(instructions.cooking_instructions)
    ? instructions.cooking_instructions
    : [];

  const thawSteps = steps.filter(step => THAW_TEXT_PATTERN.test(stepText(step)));
  const matchingThawStep = thawSteps.find(step => hasTargetThawText(step, kind));

  if (matchingThawStep) {
    instructions.cooking_instructions = [
      matchingThawStep,
      ...steps.filter(step => step !== matchingThawStep)
    ];
    return;
  }

  const copy = getThawStepCopy(language, kind);
  instructions.cooking_instructions = [
    { step_title: copy.title, details: [copy.detail] },
    ...steps.filter(step => !THAW_TEXT_PATTERN.test(stepText(step)))
  ];
};

export const normalizeRecipeFreshness = (instructions, options = {}) => {
  if (!instructions || typeof instructions !== 'object') {
    return { instructions, maxStorageTime: null, fishStoredInFreezer: false };
  }

  const storage = instructions.ingredient_storage;
  const minStorageDays = parseDays(options.minStorageDays) || 2;
  const aiMaxStorageDays = parseDays(instructions.max_storage_time);
  const requestedFishFreshnessDays = Math.max(minStorageDays, aiMaxStorageDays || 0, FISH_FRESHNESS_DAYS);
  const requestedFreshnessDays = Math.max(minStorageDays, aiMaxStorageDays || 0);
  const fishNeedsFreezer = requestedFishFreshnessDays > FISH_FREEZER_THRESHOLD_DAYS;
  const frozenFishEffectiveDays = requestedFishFreshnessDays;
  let fishStoredInFreezer = false;
  const frozenSeafoodKinds = new Set();

  if (Array.isArray(storage)) {
    for (const entry of storage) {
      if (!entry || typeof entry !== 'object') continue;

      const isFish = isFishIngredientName(entry.name);
      const days = parseDays(entry.shelf_life_days);

      // Canned / jarred / preserved proteins are shelf-stable: keep them in the
      // pantry, never force them into the fridge as fresh fish/meat.
      if (isShelfStableProteinName(entry.name)) {
        if (entry.storage !== 'pantry') {
          options.logger?.(`Shelf-stable protein "${entry.name}" kept in pantry (was ${entry.storage || 'unset'})`);
          entry.storage = 'pantry';
        }
        continue;
      }

      if (isFish) {
        if (fishNeedsFreezer) {
          if (days !== frozenFishEffectiveDays || entry.storage !== 'freezer') {
            options.logger?.(`Fish storage normalized for "${entry.name}" to freezer with effective freshness ${frozenFishEffectiveDays} days`);
          }
          entry.storage = 'freezer';
          entry.shelf_life_days = frozenFishEffectiveDays;
          fishStoredInFreezer = true;
          frozenSeafoodKinds.add(getSeafoodKind(entry.name));
        } else {
          if (days !== FISH_FRESHNESS_DAYS || entry.storage !== 'fridge') {
            options.logger?.(`Fish storage normalized for "${entry.name}" to fridge with ${FISH_FRESHNESS_DAYS}-day freshness (requested ${requestedFishFreshnessDays} days)`);
          }
          entry.shelf_life_days = FISH_FRESHNESS_DAYS;
          entry.storage = 'fridge';
        }
        continue;
      }

      // Raw meat / poultry: storage must HONOR the dish's freshness requirement
      // (dishes drive storage). Ground meat & poultry stay safe ~2 days in the
      // fridge, raw red-meat cuts ~3 days. If the dish needs to keep longer than
      // that, move the meat to the FREEZER so it survives until cooking day;
      // otherwise keep it in the fridge without overstating its life. (Already
      // frozen meat is left untouched.)
      const meatCap = getRawMeatFridgeCap(entry.name);
      if (meatCap && entry.storage !== 'freezer') {
        if (requestedFreshnessDays > meatCap) {
          if (days !== requestedFreshnessDays || entry.storage !== 'freezer') {
            options.logger?.(`Meat storage normalized for "${entry.name}" to freezer to honor ${requestedFreshnessDays}-day dish freshness (fridge safe only ${meatCap} days)`);
          }
          entry.storage = 'freezer';
          entry.shelf_life_days = requestedFreshnessDays;
        } else {
          const fridgeDays = days ? Math.min(days, meatCap) : meatCap;
          if (days !== fridgeDays || entry.storage !== 'fridge') {
            options.logger?.(`Meat storage normalized for "${entry.name}" to fridge with ${fridgeDays}-day safe life`);
          }
          entry.storage = 'fridge';
          entry.shelf_life_days = fridgeDays;
        }
        continue;
      }

      if (Number.isFinite(days) && days < minStorageDays) {
        options.logger?.(`Bumping "${entry.name}" shelf_life from ${days} to ${minStorageDays} (was ${entry.storage}${entry.storage !== 'freezer' ? ' -> freezer' : ''})`);
        entry.shelf_life_days = minStorageDays;
        if (entry.storage !== 'pantry') {
          entry.storage = 'freezer';
        }
      }
    }
  }

  if (fishStoredInFreezer) {
    ensureFishThawInstruction(instructions, options.language, resolveSeafoodThawKind(frozenSeafoodKinds));
  }

  const maxStorageTime = computeRecipeFreshnessDays(instructions);
  if (maxStorageTime) {
    instructions.max_storage_time = `${maxStorageTime}`;
  }

  return { instructions, maxStorageTime, fishStoredInFreezer };
};

export const mergeStorageDataIntoItem = (item, storageData) => {
  if (!storageData) return item;

  const itemIsFish = isFishProductItem(item);
  const shouldOverrideFishStorage = itemIsFish && storageData.storage === 'freezer';
  const existingDays = Number(item?.shelfLifeDays);
  const existingShelfLifeDays = existingDays > 0 ? existingDays : null;

  return {
    ...item,
    storage: shouldOverrideFishStorage ? storageData.storage : (item.storage || storageData.storage),
    shelfLifeDays: shouldOverrideFishStorage
      ? (storageData.shelfLifeDays || existingShelfLifeDays)
      : (existingShelfLifeDays || storageData.shelfLifeDays),
  };
};

/**
 * Accumulate ingredient_storage data for the SAME ingredient seen across
 * multiple recipes. A purchased product is bought once but may feed several
 * dishes scheduled on different days, so the storage recommendation must keep
 * it safe for the MOST demanding dish.
 *
 * Fish/seafood: freezer wins over fridge, and the longest planned freshness is
 * kept. Fridge fish is always capped at 2 days (FISH_FRESHNESS_DAYS) — a fish
 * that must last 3+ days necessarily belongs in the freezer, so we must never
 * collapse such an ingredient back to the fridge just because a shorter dish
 * was processed later.
 *
 * Non-fish: storageData is not authoritative for the storage LOCATION (the
 * deterministic classifier decides that downstream); we simply keep the latest
 * non-null values so no data is lost.
 *
 * @param {Object|null} existing - previously accumulated { storage, shelfLifeDays }.
 * @param {Object|null} incoming - new { storage, shelfLifeDays }.
 * @param {string} name - ingredient name (used to detect fish/seafood).
 * @returns {Object} merged { storage, shelfLifeDays }.
 */
export const accumulateStorageData = (existing, incoming, name) => {
  if (!existing) return incoming;
  if (!incoming) return existing;

  if (isFishIngredientName(name)) {
    const freezerWins = existing.storage === 'freezer' || incoming.storage === 'freezer';
    if (freezerWins) {
      const days = Math.max(
        Number(existing.shelfLifeDays) || 0,
        Number(incoming.shelfLifeDays) || 0
      );
      return {
        storage: 'freezer',
        shelfLifeDays: days > 0 ? days : (incoming.shelfLifeDays || existing.shelfLifeDays || null),
      };
    }
    // Both dishes keep the fish in the fridge -> enforce the 2-day fridge cap.
    return { storage: 'fridge', shelfLifeDays: FISH_FRESHNESS_DAYS };
  }

  return {
    storage: incoming.storage || existing.storage,
    shelfLifeDays: incoming.shelfLifeDays || existing.shelfLifeDays || null,
  };
};